import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { projectEndpoints } from '@/lib/api/endpoints';
import { projectKeys } from '@/lib/queryKeys';
import type { Attachment } from '@/types/attachment';

export function useProjectAttachments(projectId: string) {
  return useApiQuery<Attachment[]>({
    queryKey: projectKeys.attachments(projectId),
    queryFn: () => apiGet<Attachment[]>(operationsClient, projectEndpoints.attachments(projectId)),
    enabled: Boolean(projectId),
    showErrorToast: false,
  });
}
